<template>
  <div>
    <!-- <yd-popup v-model="isPageShow" position="center"  width="100%">
       <div class="certification-type">
          <div class="tip-str">
              <p>选择你的贷款主体，完成身份认证，提升贷款匹配精确度。</p>
          </div>
          <div class="select-type-box clearfix">
            <router-link :to="{path: '/enterpriseDetail',query: {}}" class="tab" replace>企业贷款</router-link>
            <router-link :to="{path: '/identity',query: {type:'person'}}" class="tab" replace>个人贷款</router-link>
          </div>
       </div>
    </yd-popup> -->
    <van-popup round :style="{width: '303px', height: '244px' }" v-model="isPageShow">
      <div class="prompt">
        <p>请选择下列任一身份进行认证</p>
        <div class="content">
          <div class="content-item1" @click="left">企业身份</div>
          <div class="content-item1" @click="right">个人身份</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'addCertification',
  data () {
    return {
      isPageShow:false
    }
  },
  watch: {
    isPageShow(val) {
      localStorage.setItem('companyBack',window.location.href);
      localStorage.setItem('personBack',window.location.href);
    }
  },
  methods: {
    left() {
      this.$emit('left')
    },
    right() {
      this.$emit('right')
    }
  }

}
</script>

<style lang="less" scoped>
.certification-type{width: 84%; padding: 52px 10px 38px 10px; margin: 0 auto; background-color: #fff;border-radius: 5px;}
.tip-str{font-size: 15px; line-height: 21px; color: #303030;text-align: center;display: block; padding: 0px 10px;}
.select-type-box{width: 100%; margin: 0px auto; margin-top: 90px;}
.tab{display: block;width: 49%;height: 43px; float: left;line-height: 43px;text-align: center;  border-radius: 22px;margin-right: 2%;background-color: #E4E4E4;color: #303030;font-weight: 600;}
.tab:last-child{margin-right: 0%; background-color: #E4E4E4;color: #303030;}
  .tab:active{ background-color: #3377ff;color: #fff;}

  .prompt {
    width: 100%;
    padding: 30px;
    color: #303030;
    font-size: 15px;
    font-weight: 400;
     p {
        text-align: center;
      }
    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100px;
      margin-top: 30px;
      .content-item1 {
        text-align: center;
        height: 40px;
        line-height: 40px;
        font-size: 15px;
        font-weight: 600;
        width: 100%;
        border: 1px solid #2660CE;
        border-radius: 22.5px;
        background-color: #2660CE;
        color: #fff;
        margin-top: 12px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/modules/popup/addCertification.vue